module.exports = __webpack_public_path__ + "img/voice_message.ea4e6db0.svg";